import { render, staticRenderFns } from "./gemeinde.vue?vue&type=template&id=ce33190a&"
import script from "./gemeinde.vue?vue&type=script&lang=js&"
export * from "./gemeinde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports